exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.print-only[data-v-3b0562d1] {\n  display: none;\n}\n@media print {\nimg.print-only[data-v-3b0562d1] {\n    max-width: 100%;\n    display: block;\n}\n}", ""]);

// exports
